import { TextOptions } from '@storebrand-digital/fms-translations-react/dist/helpers/types';
import { HTMLProps } from 'react';

/**
 * Render raw HTML in a component
 *
 * FMS supports markdown, but it is compiled to HTML
 * in the API layer. Use this component to render rich
 * text from FMS or other trusted source
 * (e.g. JSON Schema from insurance-claim-rest-api)
 *
 * DO NOT use if the source is not trusted.
 *
 * This thing exist mostly to make it blatantly obvious
 * where and when we are operating on "unsafe" html.
 *
 * @param value the html string
 */
export function RawHtmlFromTrustedSource({
  as: Component = 'div',
  html,
  ...props
}: {
  as?: any;
  html: string;
} & HTMLProps<HTMLElement>) {
  return <Component dangerouslySetInnerHTML={{ __html: html }} {...props} />;
}

export function fallbackToRaw(
  key: string,
  getTextFunction: (fmsKey: string, options?: TextOptions) => string
) {
  const value = getTextFunction(key, { onMissingKey: () => '' });
  if (!value) {
    return key;
  }
  return value;
}
